import useAPI from "./useApi"; // Adjust the path according to your project structure

export const useGet = (endpoint) => {
  return useAPI(endpoint, "GET");
};

export const usePost = (endpoint) => {
  return useAPI(endpoint, "POST");
};

export const usePut = (endpoint) => {
  return useAPI(endpoint, "PUT");
};

export const usePatch = (endpoint) => {
  return useAPI(endpoint, "PATCH");
};

export const useDelete = (endpoint) => {
  return useAPI(endpoint, "DELETE");
};
